<template>
  <div class="myWalletRechange">
    <van-form label-width="120px">
      <div class="myWalletRechange-radio">
        <div class="myWalletRechange-radio-label">{{ $t.myWallet.paymentMethod }}</div>
        <van-radio-group
          v-model="form.PaymentMethod"
          direction="horizontal"
          class="myWalletRechange-radio-group"
          :disabled="CEId ? true : false"
        >
          <van-radio :name="1">{{ $t.myWallet.payment1 }}</van-radio>
          <van-radio :name="2">{{ $t.myWallet.payment2 }}</van-radio>
          <van-radio :name="4">{{ $t.myWallet.payment4 }}</van-radio>
        </van-radio-group>
      </div>

      <div v-if="CEId">
        <van-field
          v-model="form.PaymentInquiryNumber"
          :label="$t.myWallet.tradeNumber"
          readonly
        />
        <van-field v-model="form.CreateTime" :label="$t.myWallet.rechargeTime" readonly />
        <van-field
          v-model="form.RemittanceAmount"
          :label="$t.myWallet.rechargeAmount"
          readonly
        />
      </div>
      <div v-else>
        <van-field
          v-model="form.PayAmount"
          :label="$t.myWallet.payAmount"
          :placeholder="$t.meta.input"
          oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          required
        />
      </div>

      <div v-if="form.PaymentMethod == 4">
        <div class="myWalletRechange-radio" v-if="!CEId">
          <div class="myWalletRechange-radio-label" style="margin-bottom: 0px">
            {{ $t.myWallet.tradeCurrency }}
          </div>
          <van-radio-group
            v-model="form.SCId"
            direction="horizontal"
            class="myWalletRechange-radio-group"
          >
            <van-radio
              :name="currency.SCId"
              v-for="(currency, index) in currencyList"
              :key="index"
              >{{ currency.CurrencySn }}</van-radio
            >
          </van-radio-group>
        </div>
        <div class="custom-field" v-else>
          <div class="custom-field-label">{{ $t.myWallet.tradeCurrency }}</div>
          <div class="custom-field-value" style="font-size: 14px">
            {{ form.CurrencySn }}
          </div>
        </div>

        <van-field
          v-model="form.AccountName"
          :label="$t.myWallet.accountName"
          :placeholder="$t.meta.input"
          :disabled="CEId ? true : false"
        />

        <van-field
          v-model="form.AccountNumber"
          :label="$t.myWallet.accountNumber"
          :placeholder="$t.meta.input"
          :disabled="CEId ? true : false"
        />

        <div class="multi-table" v-if="form.FileList">
          <van-field name="stepper" :label="$t.myWallet.payVoucher">
            <template #input>
              <van-stepper
                :min="0"
                :value="form.FileList.length"
                @minus="handleDel"
                @plus="handleAdd"
                :disable-input="true"
                :disabled="CEId ? true : false"
              />
            </template>
          </van-field>
          <div v-for="(item, index) in form.FileList" :key="index">
            <div class="multi-table-header" v-if="!CEId">
              <div class="multi-table-title"></div>
              <div class="multi-table-btn" @click="handleDelByIndex(index)">
                <van-icon name="close" />
              </div>
            </div>
            <van-field :label="'No.' + (index + 1)">
              <template #input>
                <van-button
                  @click="imagePreview(imgUrlFilter(item.FileAddress))"
                  type="primary"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-if="item.FileAddress"
                  >{{ $t.meta.view }}</van-button
                >
                <van-uploader
                  :after-read="afterRead1"
                  @click-upload="uploaderClick(index)"
                >
                  <van-image
                    :src="item.FileAddress && imgUrlFilter(item.FileAddress)"
                    width="50"
                    height="50"
                    fit="contain"
                    style="vertical-align: top"
                    v-if="item.FileAddress"
                  ></van-image>
                  <van-button
                    type="info"
                    size="small"
                    style="vertical-align: top; margin: 10px 30px 10px 0px"
                    v-else
                    >{{ $t.meta.upload }}</van-button
                  >
                </van-uploader>
              </template>
            </van-field>
          </div>
        </div>
      </div>

      <div class="custom-field">
        <div class="custom-field-label">{{ $t.myWallet.tips1 }}</div>
        <div class="custom-field-value">
          <span>{{ $t.myWallet.tips2 }}</span>
        </div>
      </div>

      <div style="margin: 16px">
        <van-button
          round
          block
          type="danger"
          v-if="checkCancelRecharge()"
          @click="customerCancelRecharge"
          >{{ $t.myWallet.cancelPayment }}</van-button
        >
      </div>
    </van-form>

    <div class="tool-bar" v-if="checkContinueRecharge()">
      <van-button type="info" block @click="onSubmit">{{
        $t.myWallet.payNow
      }}</van-button>
    </div>
  </div>
</template>
<script>
import { isAPP } from "@/plugins/environment/type.js";
import Vue from "vue";

import {
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Image,
  Stepper,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Image)
  .use(Stepper)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "myWalletRechange",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isApp: isAPP(),
      CEId: "",
      currencyList: [],
      form: {
        PaymentMethod: 1,
        PayAmount: null,
        SCId: null,
        AccountName: "",
        AccountNumber: "",
        WxReturnCodeType: null,
        FileList: [],
      },
      filesIndex: 0,
    };
  },
  created() {
    const { CEId } = this.$route.query;
    this.CEId = CEId;
    if (this.CEId) {
      this.getCurrencyList().then((success) => {
        if (success) {
          this.getCustomerBillDetailsByCEId();
        }
      });
    } else {
      this.getCurrencyList();
    }
  },
  methods: {
    checkContinueRecharge() {
      if (!this.CEId) {
        return true;
      }
      if (this.form.PaymentMethod == 1 || this.form.PaymentMethod == 2) {
        if (this.form.OrderState == 0) {
          return true;
        }
      }
      return false;
    },
    checkCancelRecharge() {
      if (!this.CEId) {
        return false;
      }
      if (this.form.PaymentMethod == 1 || this.form.PaymentMethod == 2) {
        if (this.form.OrderState == 0) {
          return true;
        }
        return false;
      }
      if (this.form.PaymentMethod == 4) {
        if (this.form.EntryState == 1 || this.form.EntryState == 2) {
          return false;
        }
      }
      return true;
    },
    customerCancelRecharge() {
      this.$commonMethod.showLoading();
      var param = {
        CEId: this.CEId,
      };
      this.$api.onlineOrderManagement
        .customerCancelRecharge(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            this.currencyList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    handleAdd() {
      this.form.FileList.push({
        FileAddress: "",
      });
    },
    handleDel() {
      if (this.form.FileList && this.form.FileList.length > 0) {
        this.form.FileList.pop();
      }
    },
    handleDelByIndex(index) {
      this.form.FileList.splice(index, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getCustomerBillDetailsByCEId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          CEId: this.CEId,
        };
        this.$api.onlineOrderManagement
          .getCustomerBillDetailsByCEId(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CEId = this.CEId;
      this.$api.onlineOrderManagement
        .customerAccountRecharge(param)
        .then((res) => {
          var data = res.data.linkUrl;
          if (this.form.PaymentMethod == 1 || this.form.PaymentMethod == 2) {
            //支付宝 和 微信
            var param = {
              paymentMethod: this.form.PaymentMethod,
              linkUrl: data,
            };
            localStorage.setItem("payQrcode", JSON.stringify(param));
            this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
              isParams: false,
              path: "payQrcode",
              name: "payQrcode",
              query: [],
            });
          }
          if (this.form.PaymentMethod == 4) {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
              titleMsg: res.message,
              type: "success",
            });
            //线下支付
            this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileList[this.filesIndex].FileAddress = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.myWalletRechange {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #646566 !important;
    -webkit-text-fill-color: #646566 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 120px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      color: #646566;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .myWalletRechange-radio {
    color: #646566;
    padding: 12px 16px;
    font-size: 14px;
    border-bottom: 1px solid #ebedf0;
    ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
      i {
        color: #1890ff;
        font-weight: bold;
      }
    }
    ::v-deep .van-radio__label--disabled.van-radio__label {
      color: #646566 !important;
      -webkit-text-fill-color: #646566 !important;
    }
    ::v-deep .van-field--disabled {
      .van-field__label,
      .van-field__control {
        color: #646566 !important;
        -webkit-text-fill-color: #646566 !important;
      }
    }
    .myWalletRechange-radio-label {
      display: inline-block;
      vertical-align: middle;
      width: 120px;
      margin-bottom: 10px;
    }
    .myWalletRechange-radio-group {
      display: inline-flex;
      vertical-align: middle;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
